import { BasicResponse } from "./basicResponse";

export class PropertyViewsRepsonse extends BasicResponse{
    public propertyId?:number;
    public views:PropertyViews[] = [];
}

export class PropertyViews{
    public userId?:string;
    public views!:number;
    public firstName? :string;
    public lastName? : string;
    public lastViewed! : string;
    public isFavorite : boolean = false;

    get fullName():string{
        return this.lastName? (this.firstName + ' ' + this.lastName) : "Unknown";
    }

    get lastViewedDate():Date{
        return new Date(this.lastViewed);
    }
}